/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED VIDEO ADs : STYLES --------------- ++++++++++ */
export default theme => ({
	videoads: {
		opacity: '0',
        animationName: 'fadeInUp',
        animationDuration: '.2s',
        animationFillMode: 'forwards',
        animationDelay: '.4s',

		display: `flex`,
		flexDirection: `column`,
		justifyContent: `center`,
		marginLeft: pxToEm(20),
		paddingLeft: pxToEm(60),
		borderLeft: replacePXinStringWithEM(`1px solid rgb(232, 235, 242)`),
		textAlign: 'left',
		'& .videographic': {
			background: `#eee`,
			border: replacePXinStringWithEM(`1px solid #ccc`) ,
			width: pxToEm(85),
			height: pxToEm(50),
			marginBottom: pxToEm(25),
			display: 'inline-flex',
			alignItems: 'center',
			justifyContent: 'center',
			'& .icon': {
				fontSize: '165%'
			}
		},
		'& .copy': {
			maxWidth: pxToEm(215),
			'& .title': {
				'& h2': {
					fontSize: pxToEm(18),
					fontWeight: 'bold'
				}
			},
			'& .bodycopy': {
				'& p': {
					fontSize: pxToEm(15),
					lineHeight: '1.1'
				}
			}
		},
		'& .selections': {
			'& .selection': {
				display: 'flex',
				margin: replacePXinStringWithEM(`10px 10px 10px 0`),
				'& .container': {
					'&.imagery': { width: pxToEm(30), textAlign: 'center' },
					'&.desc': { width: pxToEm(80) }
				},
				'& .icon': {
					marginRight: pxToEm(5)
				},
				'& .devicename': {
					color: '#7f93b9'
				},
				'& .toggle': {
					fontSize: '60%'
				},
				'&:last-child': {
					marginRight: '0'
				}
			}
		}
    },

    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[`@media only screen and (min-width:${pxToEm(0)}) and (max-width:${pxToEm(1398)})`]: { 
		videoads: {
			borderLeft: '0',
			borderTop: replacePXinStringWithEM(`1px solid rgb(232, 235, 242)`),
			margin: replacePXinStringWithEM(`40px auto 0`),
			padding: replacePXinStringWithEM(`60px 0 0`),
			textAlign: 'center',
			width: '90%',
			'& .videographic': { marginLeft: 'auto', marginRight: 'auto' },
			'& .copy': { 
				margin: '0 auto',
				maxWidth: pxToEm(400),
				'& .bodycopy': {
					'& p': {
						fontSize: pxToEm(16),
						lineHeight: '1.5'
					}
				}
			},
			'& .selections': {
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				'& .selection': {
					marginRight: pxToEm(20),
					'& .container': {
						'&.imagery': { width: 'auto', textAlign: 'left' },
						'&.desc': { width: 'auto' }
					},
					'& .icon': {
						fontSize: '110%'
					},
					'& .toggle': {
						marginLeft: pxToEm(7)
					}
				}
			}
		}
	}
});
